import { cva } from 'class-variance-authority';

export const buttonClasses = cva(
  [
    'min-w-fit',
    'inline-flex',
    'items-center',
    'border',
    'font-medium',
    'shadow-xs',
    'focus-visible:outline-solid',
    'focus-visible:outline-2',
    'focus-visible:outline-offset-2',
    'focus-visible:outline-gray-600',
    'transition-colors',
    'duration-300',
    'ease-in-out',
  ],
  {
    variants: {
      variant: {
        dark: 'border-info-300 text-info-700 hover:bg-info-50 gap-x-2 rounded-sm bg-white py-[7px] pr-[11px] pl-[9px] text-xs',
        light: 'text-info-700 gap-x-1.5 rounded-md px-2.5 py-1.5 text-sm hover:bg-black/5',
      },
    },
  },
);

export const containerClasses = cva(['relative', 'flex w-full', 'shrink-0', 'flex-col', 'py-4'], {
  variants: {
    variant: {
      dark: 'bg-info-700 text-info-300',
      light: 'text-info-800',
    },
    isOpen: {
      true: 'gap-5',
      false: 'gap-2',
    },
    isCollapsed: {
      true: 'items-center',
      false: 'px-4',
    },
  },
  defaultVariants: {
    variant: 'dark',
    isCollapsed: false,
  },
});
export const nameClasses = cva(['text-sm', 'font-medium', 'truncate', 'text-left', 'pr-2'], {
  variants: {
    variant: {
      dark: 'text-white',
      light: 'text-info-500',
    },
  },
});
